import { cva as e } from "class-variance-authority";
const a = e(
  [
    "inline-flex items-center justify-center gap-xsmall",
    "text-bodyRegularStrong",
    "box-border rounded-full",
    "cursor-pointer whitespace-nowrap no-underline",
    "hover:no-underline",
    "focus:&:not(:focus-visible):outline-none",
    "focus-visible:outline-2 focus-visible:ring-2",
    "focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-accent",
    "focus-visible:ring-surface"
  ],
  {
    variants: {
      /**
       * Main style of the button.
       */
      variant: {
        primary: [
          "border-2 border-solid border-primary bg-primary text-onPrimary"
        ],
        secondary: [
          "border-2 border-solid border-utility bg-transparent text-interactive"
        ],
        ghost: ["bg-transparent text-secondary"],
        critical: [
          "border-2 border-solid border-utility bg-transparent text-critical"
        ]
      },
      /**
       * Size of the button.
       */
      size: {
        small: ["h-xlarge min-h-xlarge min-w-xlarge"],
        medium: ["h-[44px] min-h-[44px] min-w-[44px]"]
      },
      /**
       * Disable the button, preventing user interaction and adding opacity.
       */
      disabled: {
        true: ["opacity-medium hover:cursor-not-allowed"],
        false: null
      },
      loading: {
        true: ["hover:cursor-not-allowed"]
      },
      iconButton: {
        true: ["p-none"],
        false: ["w-fit px-medium"]
      }
    },
    compoundVariants: [
      {
        variant: "primary",
        disabled: !1,
        loading: !1,
        className: [
          "hover:border-primaryContainer hover:bg-primaryContainer hover:text-onPrimaryContainer",
          "active:border-primaryContainer active:bg-primaryContainer active:text-onPrimaryContainer"
        ]
      },
      {
        variant: "secondary",
        disabled: !1,
        loading: !1,
        className: [
          "hover:border-secondary hover:bg-secondaryContainer hover:text-onSecondaryContainer",
          "active:border-secondary active:bg-secondaryContainer active:text-onSecondaryContainer"
        ]
      },
      {
        variant: "ghost",
        disabled: !1,
        loading: !1,
        className: [
          "hover:bg-secondaryContainer hover:text-onSecondaryContainer",
          "active:bg-secondaryContainer active:text-onSecondaryContainer"
        ]
      },
      {
        variant: "critical",
        disabled: !1,
        loading: !1,
        className: [
          "hover:border-critical hover:bg-criticalContainer hover:text-onCriticalContainer",
          "active:border-critical active:bg-criticalContainer active:text-onCriticalContainer"
        ]
      },
      {
        variant: "primary",
        disabled: !0,
        className: [
          "hover:bg-primary hover:text-onPrimary",
          "active:bg-primary active:text-onPrimary"
        ]
      },
      {
        variant: "secondary",
        disabled: !0,
        className: [
          "hover:border-utility hover:bg-transparent hover:text-interactive",
          "active:border-utility active:bg-transparent active:text-interactive"
        ]
      },
      {
        variant: "ghost",
        disabled: !0,
        className: [
          "hover:bg-transparent hover:text-secondary",
          "active:bg-transparent active:text-secondary"
        ]
      },
      {
        variant: "critical",
        disabled: !0,
        className: [
          "hover:border-utility hover:bg-transparent hover:text-critical",
          "active:border-utility active:bg-transparent active:text-critical"
        ]
      },
      {
        iconButton: !0,
        size: "small",
        className: ["size-xlarge"]
      },
      {
        iconButton: !0,
        size: "medium",
        className: ["size-[44px]"]
      }
    ],
    defaultVariants: {
      variant: "primary",
      size: "medium",
      disabled: !1,
      loading: !1,
      iconButton: !1
    }
  }
);
export {
  a as buttonStyles
};
